<ng-container *ngIf="options.length">
    <ng-container *ngIf="isYesNoQuestion">
        <mg-configurator-checkbox
            [checkedValue]="true"
            [formControl]="componentFormControl"
            [label]="{ optionName: configurationOption.name, key: 'checkboxLabel' } | optionTranslation | async"
            [optionName]="configurationOption.name"
            [description]="
                {
                    optionName: configurationOption.name,
                    key: 'optionDescription',
                    selectableOptionId: 'checkbox_description'
                }
                    | optionTranslation
                    | async
            "
            [uncheckedValue]="false"
        ></mg-configurator-checkbox>
    </ng-container>

    <ng-container *ngIf="!isYesNoQuestion">
        <mg-configurator-optiongroup *ngIf="options.length < 5" [formControl]="componentFormControl">
            <mg-configurator-optiongroup-option
                *ngFor="let option of options"
                [label]="option.name || option.label"
                [description]="
                    {
                        optionName: configurationOption.name,
                        key: 'optionDescription',
                        selectableOptionId: option.labelId
                    }
                        | optionTranslation
                        | async
                "
                [value]="option.id"
            >
                <mg-ui-modal [keys]="[option.labelId, option.label]">
                    <mat-icon class="configurator-icon-modal">info_outline</mat-icon>
                </mg-ui-modal>
            </mg-configurator-optiongroup-option>
        </mg-configurator-optiongroup>

        <mg-configurator-select *ngIf="options.length >= 5" [formControl]="componentFormControl">
            <mg-configurator-select-option
                *ngFor="let option of options"
                [label]="option.name"
                [value]="option.id"
            ></mg-configurator-select-option>
        </mg-configurator-select>
    </ng-container>
</ng-container>
